import { IconButton } from '@ui-components/neo.tax';
import React from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { StyledCloseIcon, StyledInput, StyledSearchIcon } from './keyword-search.styled';

export const KeywordSearch = ({
  autoFocus = false,
  className,
  disableClearSearch = false,
  disableHighlight = false,
  id,
  searchKeyword,
  setSearchKeyword,
}: {
  autoFocus?: boolean;
  className?: string;
  disableClearSearch?: boolean;
  disableHighlight?: boolean;
  searchKeyword: string | null;
  setSearchKeyword: React.Dispatch<React.SetStateAction<string | null>>;
  id?: string;
}): React.ReactElement => {
  const [value, setValue] = React.useState(searchKeyword);

  const onChange = useDebouncedCallback((value: string | null) => {
    setSearchKeyword(value);
  }, 200);

  const onClearSearch = (): void => {
    setValue(null);
    onChange(null);
  };

  React.useEffect(() => {
    setValue(searchKeyword);
  }, [searchKeyword]);

  return (
    <StyledInput
      id={id}
      className={className}
      value={value || ''}
      onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
        setValue(e.target.value);
        onChange(e.target.value);
      }}
      placeholder="Quick Find"
      isActive={!disableHighlight && !!value}
      inlineLeadingContent={<StyledSearchIcon />}
      inlineTrailingContent={
        !disableClearSearch && (
          <IconButton
            active={false}
            disabled={!value}
            variant="transparent"
            icon={{
              node: <StyledCloseIcon />,
              isNotificationToggled: false,
            }}
            onClick={onClearSearch}
            rounded="regular"
            size="sm"
          />
        )
      }
      autoFocus={autoFocus}
    />
  );
};
